import React, { Component } from 'react';
import { motion } from 'framer-motion';
// 🔧 Atualize com o número real (formato internacional, só dígitos)
const PHONE = '5511941074818';
const MESSAGE = 'Olá! Eu quero saber mais detalhes sobre a Aurora.';
export function WhatsAppButton() {
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;
  return <motion.a href={href} target="_blank" rel="noopener noreferrer" aria-label="Fale conosco no WhatsApp" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    type: 'spring',
    stiffness: 200,
    damping: 18,
    delay: 1.2
  }} whileHover={{
    scale: 1.08
  }} whileTap={{
    scale: 0.95
  }} className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-[60] w-14 h-14 md:w-16 md:h-16 flex items-center justify-center no-underline group" data-id="element-678">
      <img src="https://cdn.magicpatterns.com/uploads/tfB82vp9xDc6VnMKbYnX77/wpp-removebg.png" alt="WhatsApp" className="w-full h-full object-contain drop-shadow-lg" data-id="element-679" />

      {/* Tooltip on hover (desktop) */}
      <span className="hidden md:block absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-ink text-white text-xs font-medium px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none" data-id="element-680">
        Fale com a gente
      </span>
    </motion.a>;
}